import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-innactive-organisation',
    templateUrl: './innactive-organisation.component.html',
    styleUrls: ['./innactive-organisation.component.scss']
})
export class InnactiveOrganisationComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
